import { Component, EventEmitter, Input, Output } from '@angular/core';
import PlacementInvoice from 'src/app/model/invoice/placement-invoice';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'ip-board-company-invoice',
  templateUrl: './ip-board-company-invoice.component.html',
  styleUrls: ['./ip-board-company-invoice.component.scss']
})
export class IPBoardCompanyInvoiceComponent {
  @Input()
  placementInvoice: PlacementInvoice;
  @Input()
  multiple: boolean;
  @Input()
  showSave = false;
  @Input()
  savingLines = false;
  @Output()
  save = new EventEmitter<any>();
  @Output()
  saveLines = new EventEmitter();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  emitSave(): void {
    this.save.emit();
    this.projectDisplayObservableService
      .getProjectInvoicePriceChangedSubscribable()
      .next();
  }
}
